const noIndex = { name: 'robots', content: 'noindex' }

export default {

  // no indexable guest pages
  privacy: {
    url: '/privacy',
    title: 'Privacy Policy',
    meta: [
      noIndex
    ]
  },
  termsAndConditions: {
    url: '/terms-and-conditions',
    title: 'Terms & Conditions',
    meta: [
      noIndex
    ]
  },
  notInterested: {
    // when someone clicks "not interested" on the email invite
    url: '/not-interested',
    title: 'Unsubscribe',
    meta: [
      noIndex
    ]
  },
  forgotPassword: {
    url: '/forgot-password',
    title: 'Forgot Password',
    meta: [
      noIndex
    ]
  },
  resetPassword: {
    url: '/reset-password',
    title: 'Reset Password',
    meta: [
      noIndex
    ]
  },
  embed: {
    url: '/embed',
    title: 'Kintell Cards',
    meta: [
      noIndex
    ]
  },
  welcome: {
    url: '/welcome',
    title: 'Welcome to Kintell',
    meta: [
      noIndex
    ]
  },

  giftcards: {
    url: '/giftcards',
    title: 'Kintell Gift Cards',
    description: 'If you’ve been sent a Kintell gift card or code you can use your credits to book an advisor of your choice.',
  },

  // indexable guest pages
  pricing: {
    url: '/pricing',
    title: 'Pricing',
    description: 'As a learner you only pay when you make a booking, with the rates being set by the advisors. As an advisor, we take an admin fee from your booking income.',
  },

  becomeAnAdvisor: {
    url: '/become-an-advisor',
    title: 'Become an advisor',
    description: 'Become a Kintell advisor - it’s a great way of generating additional income from your untapped skills and experience, at a time and place that suits you.',
  },

  // round up pages
  digitalMarketing: {
    url: '/digital-marketing',
    title: 'Digital Marketing Roundup',
    description: 'We\'ve rounded up 10 of the best digital marketing advisors who can help you with Google Ads (PPC), Anaytics, Facebook Ads, content marketing, SEO and more.',
    image: '~images/roundup/coaches-full.jpeg',
  },
  health: {
    url: '/health',
    title: 'Health Roundup',
    description: 'Get practical guidance on everything from boosting your natural energy levels to fitting good nutrition into a busy lifestyle.',
    image: '~images/roundup/health-full.jpeg',
  },
  coaches: {
    url: '/coaches',
    title: 'Coaches Roundup',
    description: 'We have a range of amazing coaches to help you be the best you can be, in everything from communication techniques to effective leadership.',
    image: '~images/roundup/coaches-full.jpeg',
  },
  startup: {
    url: '/startup',
    title: 'Startup Roundup',
    description: 'Tap in to a world of knowledge on starting, funding, growing, marketing, and leading your own business, with insights from our experienced startup advisors.',
    image: '~images/roundup/startup-full.jpeg',
  },

  search: {
    url: '/search',
    title: 'Find an advisor'
  },
  login: {
    url: '/sign-in',
    title: 'Sign in'
  },
  faqs: {
    url: '/faq',
    title: 'FAQs'
  },
  getInTouch: {
    url: '/get-in-touch',
    title: 'Contact Us'
  },

  browseByCategory: {
    url: '/browse-by-category',
    title: 'Browse by category',
    description: 'Try using our carefully-curated categories to browse through the Kintell Advisors.',
  },
  codeOfConduct: {
    url: '/code-of-conduct',
    title: 'Code of Conduct',
    description: 'Kintell was created to empower people from all walks of life, so maintaining an inclusive, transparent, and trustworthy community is key.',
  },
  cancellationPolicy: {
    url: '/cancellation-policy',
    title: 'Cancellation Policy',
  },
  articles: {
    url: '/articles',
    title: 'Articles'
  },
  joinNow: {
    url: '/join-now',
    title: 'Join Now',
  },

  // authenticated
  dashboard: {
    url: '/my-kintell/dashboard',
    title: 'Overview'
  },
  bookings: {
    url: '/my-kintell/bookings',
    title: 'Confirmed Bookings'
  },
  bookingRequests: {
    url: '/my-kintell/bookings/requests',
    title: 'Booking Requests'
  },
  personalDetails: {
    url: '/my-kintell/my-details',
    title: 'My Profile'
  },
  advisorSettings: {
    url: '/my-kintell/my-details/advisor-settings',
    title: 'Advisor Settings'
  },
  billing: {
    url: '/my-kintell/my-details/billing',
    title: 'Billing'
  },
  myKintellCards: {
    url: '/my-kintell/kintell-cards',
    title: 'Kintell Cards'
  },
  createKintellCard: {
    url: '/my-kintell/kintell-cards/create',
    title: 'Create Kintell Card'
  },
  myRewards: {
    url: '/my-kintell/my-rewards',
    title: 'Invites & Rewards'
  },
  favourites: {
    url: '/my-kintell/favourites',
    title: 'Favourites'
  },
  privateFavourites: {
    url: '/my-kintell/favourites/private',
    title: 'Favourites'
  },
  credits: {
    url: '/my-kintell/credits',
    title: 'Credits'
  },
  calendar: {
    url: '/my-kintell/my-calendar',
    title: 'My Calendar'
  },
  syncSettings: {
    url: '/my-kintell/my-calendar/sync-settings',
    title: 'Sync Settings'
  },
  workingHours: {
    url: '/my-kintell/my-calendar/working-hours',
    title: 'Working Hours'
  },
  bookingArchive: {
    url: '/my-kintell/bookings/archive',
    title: 'Bookings Archive'
  },
  initiateABooking: {
    url: '/my-kintell/bookings/initiate',
    title: 'Initiate a Booking'
  },
  signOut: {
    url: '/sign-out',
    title: 'Sign Out'
  },
}
